export default [
    {
        name: "ADAMS",
        id: ''
    },
    {
        name: "aLEPH BET JEWISH DAY SCHOOL",
        id: ''
    },
    {
        name: "APOLLO AFTER SCHOOL",
        id: ''
    },

    {
        name: "BALLENGER CREEK",
        id: ''
    },
    {
        name: "BANNACKBURN ELEMENTARY",
        id: ''
    },
    {
        name: "BARRET ELEMENTARY",
        id: ''
    },
    
    {
        name: "C3 CYBER CLUB - TECH ACADEMY",
        id: ''
    },
    {
        name: "CARDEROCK SPRINGS ELEMENTARY",
        id: ''
    },
    {
        name: "CEDAR GROVE",
        id: ''
    },

    {
        name: "DAYTON OAKS",
        id: ''
    },
    {
        name: "DEEP RUN",
        id: ''
    },
    {
        name: "DIAMOND ELEMENTARY",
        id: ''
    },

    {
        name: "ELKRIDGE",
        id: ''
    },{
        name: "EMERICK ELEMENTARY",
        id: ''
    },{
        name: "EXCELLENCE CHRISTIAN SCHOOL",
        id: ''
    },

    {
        name: "FAIRFAX VILLA ELEMENTARY",
        id: ''
    },{
        name: "FALLS CHURCH COMMUNITY CENTER",
        id: ''
    },{
        name: "FOREST EDGE",
        id: ''
    },

    {
        name: "GORMAN CROSSING",
        id: ''
    },{
        name: "GREAT FALLS ELEMENTARY",
        id: ''
    },{
        name: "GREEN ACRES SCHOOL",
        id: ''
    },

    {
        name: "HALLIE WELLS",
        id: ''
    },{
        name: "HAMMOND",
        id: ''
    },{
        name: "HAYMARKET ELEMENTARY",
        id: ''
    },

    {
        name: "IDA LEE",
        id: ''
    },{
        name: "IT'S ELEMENTARY",
        id: ''
    },
    
    {
        name: "JAMESTOWN ELEMENTARY",
        id: ''
    },{
        name: "JOHN F. PATTIE",
        id: ''
    },{
        name: "JOHN HANSON MONTESSORI SCHOOL",
        id: ''
    },

    {
        name: "KENNETH CULBERT",
        id: ''
    },{
        name: "KENSINGTON PARKWOOD",
        id: ''
    },{
        name: "KENT GARDENS",
        id: ''
    },

    {
        name: "LAFAYETTE ELEMENTARY",
        id: ''
    },{
        name: "LAKEWOOD ELEMENTARY",
        id: ''
    },{
        name: "LANHAM CHRISTIAN SCHOOL",
        id: ''
    },

    {
        name: "MANOR WOODS",
        id: ''
    },{
        name: "MARET",
        id: ''
    },{
        name: "MATTAPONI ELEMENTARY",
        id: ''
    },

    {
        name: "NANNIE J LEE RECREATION CENTER",
        id: ''
    },{
        name: "NEW HOPE ACADEMY",
        id: ''
    },{
        name: "NEW MARKET",
        id: ''
    },

    {
        name: "OAK HILL ELEMENTARY",
        id: ''
    },{
        name: "OAK MARR RECREATION CENTER",
        id: ''
    },{
        name: "OAKDALE RECREATION CENTER",
        id: ''
    },

    {
        name: "PAT WHITE AT BEN LOMOND",
        id: ''
    },{
        name: "PHILOMONT COMMUNITY CENTER",
        id: ''
    },{
        name: "PINECREST ES",
        id: ''
    },

    {
        name: "ROBERTO CLEMENTE MIDDLE",
        id: ''
    },{
        name: "ROCK CREEK FOREST",
        id: ''
    },{
        name: "ROCKBURN",
        id: ''
    },

    {
        name: "SCHOOL WITHOUT WALLS AT FRANCIS-STEVENS",
        id: ''
    },{
        name: "SELDENS LANDING",
        id: ''
    },{
        name: "SHARON C. MCAULIFFE ELEMENTARY",
        id: ''
    },

    {
        name: "THE NEWTON SCHOOL",
        id: ''
    },{
        name: "THUNDER HILL",
        id: ''
    },{
        name: "THURMONT RECREATION CENTER",
        id: ''
    },

    {
        name: "URBANA ELEMENTARY SCHOOL",
        id: ''
    },

    {
        name: "VETERANS MEMORIAL PARK",
        id: ''
    },{
        name: "VICTORY CHRISTIAN SCHOOL",
        id: ''
    },{
        name: "VIENNA REC CENTER",
        id: ''
    },

    {
        name: "WAPLES MILLS",
        id: ''
    },{
        name: "WASHINGTON EPISCOPAL",
        id: ''
    },{
        name: "WAVERLY",
        id: ''
    },
]